import { BundleMiniItem, BundleLaundryMiniItem, MultiParentCarousel } from './bundle-item/index';

const Templates = {
  BundleMiniItem,
  BundleLaundryMiniItem,
  MultiParentCarousel
};

export const getTemplate = (templateName) => Templates?.[templateName] || null;
export const getNormalizedProps = ({ bundles, isMultiParent, ...props }) => {
  return isMultiParent
    ? { bundles: Array.isArray(bundles) ? bundles : [bundles], ...props }
    : { bundleData: Array.isArray(bundles) ? bundles[0] : bundles, ...props };
};